/*
 * A team's second line (decision 714; Kevin, 2026-10-12): the team, and the
 * teammates nobody here tracks.
 *
 *   AFM-2 - with teammates: Luana Le, Yixin Li
 *
 * One component for Active's card, Upcoming's entry and Past's result, so the
 * three views cannot word it differently. The team alone when every member is
 * tracked -- the first line already names them all.
 */

import type { ElementType } from "react";
import { useTranslation } from "react-i18next";

import type { TeamMember } from "../lib/api";
import { teamNames } from "../lib/team";

export function TeamLine({
  teamName,
  members,
  className,
  as: Tag = "div",
}: {
  teamName: string;
  members: TeamMember[] | null | undefined;
  className?: string | undefined;
  as?: ElementType;
}) {
  const { t } = useTranslation();
  const mates = teamNames(members).teammates;
  return (
    <Tag className={className}>
      {mates.length > 0
        ? t("team.withTeammates", { team: teamName, names: mates.join(t("team.nameSeparator")) })
        : teamName}
    </Tag>
  );
}
